import {connect} from "react-redux";
import MrfApprovalListing from "./list";
import {bindActionCreators} from "redux";
import {
    getPending
} from "../../../services/redux/MaterialRequistionForm/action";

const mapStateToProps = (state) => ({
    pendingListing: state.MaterialRequistionForm.pendingListing,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getPending
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MrfApprovalListing);
